import { uniq } from 'lodash';
import { getAccessorialRequests } from 'utils/AccessorialRequestWebAPIUtils';
import { getAccessorialRequestRule } from 'utils/UserServiceAPIUtils';

export async function getShipperAccessorialDocumentRequirements(shipment) {
  try {
    const query = {
      shipment: shipment._id || shipment,
      shipper_status: { $nin: ['canceled', 'declined'] }
    };
    const result = await getAccessorialRequests(query);
    if (!result?.data?.success) {
      throw new Error('ERROR_RETRIEVING_CURRENT_ACCESSORIAL_REQUESTS');
    }
    const { request } = result.data;
    const accessorialDocumentRulesRequired = uniq(request.map((r) => r.accessorial_type));
    const shipperId = shipment.shipper?._id || shipment.shipper;
    const rules = await getAccessorialRequestRule(shipperId, { accessorials: accessorialDocumentRulesRequired });
    if (!rules?.data?.getAccessorialRequestRule?.items) {
      throw new Error('ERROR_RETRIEVING_ACCESSORIAL_DOCUMENT_REQUIREMENTS');
    }
    const { items: accessorialRequirements } = rules.data.getAccessorialRequestRule;

    const accessorialDocumentRequirements = accessorialRequirements.reduce((allDocuments, accessorial) => {
      return allDocuments.concat(accessorial?.rules.map((rule) => rule.value));
    }, []);

    return accessorialDocumentRequirements;
  } catch (e) {
    throw e;
  }
};

export async function getAllShipperDocumentRequirements(shipment, stopDocumentsConfig) {
  try {
    const accessorialDocumentRequirements = await getShipperAccessorialDocumentRequirements(shipment);
    /*
      Get documents required according to our movement type and shipment type and then gather the document requirements per the stops on our shipment
    */
    const { order_type, shipment_type, stops } = shipment;
    const shipmentTypeKey = `${order_type.toUpperCase()}_${shipment_type.toUpperCase()}`;
    const stopKeys = _getStopTypeKeysRequired(stops);

    const stopDocumentRequirements = stopKeys.reduce((allStopDocRequirements, stopKey) => {
      const orderType = stopDocumentsConfig[shipmentTypeKey];
      if (!(orderType && orderType[stopKey])) {
        return allStopDocRequirements;
      }
      return allStopDocRequirements.concat(stopDocumentsConfig[shipmentTypeKey][stopKey]);
    }, []);

    return uniq(accessorialDocumentRequirements.concat(stopDocumentRequirements));
  } catch (e) {
    throw e;
  }
};

function _getStopTypeKeysRequired(stops) {
  return uniq(stops.reduce((keys, stop) => {
    const { off_site, action, empty } = stop;

    let key = '';

    if (off_site) {
      key += 'OFFSITE';
    }

    if (empty) {
      key += key === '' ? 'EMPTY' : '_EMPTY';
    } else {
      key += key === '' ? 'LOADED' : '_LOADED';
    }

    const stopAction = action.toUpperCase();

    key += key === '' ? `${stopAction}` : `_${stopAction}`;

    return keys.concat(key);
  }, []));
};
